// Feather-name -> lucide-react icon, so ported screens keep their icon names.
import {
  Mic, Heart, Clock, Users, Smartphone, Play, ArrowRight, Check, Settings,
  Sun, X, User, MessageCircle, RefreshCw, Award, Sliders, Calendar, Bookmark,
  Eye, EyeOff, Square, Send, Edit3, PhoneOff, Feather, Moon, CheckCircle,
  Volume2, ChevronLeft, ChevronRight, BookOpen, Mail, Zap, Shield, Trash2,
  PhoneCall, AlertCircle, Smile, Meh, Cloud, CloudDrizzle, UserPlus, Star,
  CreditCard, LogOut, AlertTriangle, Plus, Upload, PauseCircle, Loader, Circle,
} from "lucide-react";

const MAP = {
  mic: Mic, heart: Heart, clock: Clock, users: Users, smartphone: Smartphone,
  play: Play, "arrow-right": ArrowRight, check: Check, settings: Settings,
  sun: Sun, x: X, user: User, "message-circle": MessageCircle, "refresh-cw": RefreshCw,
  award: Award, sliders: Sliders, calendar: Calendar, bookmark: Bookmark, eye: Eye,
  "eye-off": EyeOff, square: Square, send: Send, "edit-3": Edit3, "phone-off": PhoneOff,
  feather: Feather, moon: Moon, "check-circle": CheckCircle, "volume-2": Volume2,
  "chevron-left": ChevronLeft, "chevron-right": ChevronRight, "book-open": BookOpen,
  mail: Mail, zap: Zap, shield: Shield, "trash-2": Trash2, "phone-call": PhoneCall,
  "alert-circle": AlertCircle, smile: Smile, meh: Meh, cloud: Cloud,
  "cloud-drizzle": CloudDrizzle, "user-plus": UserPlus, star: Star, "credit-card": CreditCard,
  "log-out": LogOut, "alert-triangle": AlertTriangle, plus: Plus, upload: Upload,
  "pause-circle": PauseCircle, loader: Loader,
};

export default function Icon({ name, size = 24, color, strokeWidth = 2, style }) {
  const C = MAP[name] || Circle;
  return <C size={size} color={color} strokeWidth={strokeWidth} style={style} />;
}
